import { LOCALES_MAP } from 'prismic/config';

export const mapNextLocaleToISOLanguageCode = (nextLocale: string): string => {
  // Next.js returns variable  "locale" thta contains the language of url
  return LOCALES_MAP[nextLocale];
};
